var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "times",
    d: "M9.091,103.5,13.9,98.693l.991-.991a.375.375,0,0,0,0-.53L13.829,96.11a.375.375,0,0,0-.53,0l-5.8,5.8-5.8-5.8a.375.375,0,0,0-.53,0L.11,97.17a.375.375,0,0,0,0,.53l5.8,5.8-5.8,5.8a.375.375,0,0,0,0,.53l1.061,1.061a.375.375,0,0,0,.53,0l5.8-5.8,4.808,4.808.991.991a.375.375,0,0,0,.53,0l1.061-1.061a.375.375,0,0,0,0-.53Z",
    transform: "translate(0 -96)",
    fill: "#535353"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/times.12c8457837fca834f9a860fb04c79e99.svg";